
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { useCustomLabels } from '@/hooks/useCustomLabels';
import { Link, useLocation } from 'react-router-dom';
import { Home, Compass, Info } from 'lucide-react';

const KeypadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="h-5 w-5"
  >
    <rect x="4" y="4" width="4" height="4" rx="1" />
    <rect x="10" y="4" width="4" height="4" rx="1" />
    <rect x="16" y="4" width="4" height="4" rx="1" />
    <rect x="4" y="10" width="4" height="4" rx="1" />
    <rect x="10" y="10" width="4" height="4" rx="1" />
    <rect x="16" y="10" width="4" height="4" rx="1" />
    <rect x="4" y="16" width="4" height="4" rx="1" />
    <rect x="10" y="16" width="4" height="4" rx="1" />
    <rect x="16" y="16" width="4" height="4" rx="1" />
  </svg>
);

const Footer = () => {
  const { t } = useLanguage();
  const { getLabel } = useCustomLabels();
  const location = useLocation();
  
  // Helper function to determine if a link is active
  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return true;
    if (path === '/tours' && location.pathname.startsWith('/tours')) return true;
    if (path === '/exhibit-access' && (location.pathname === '/exhibit-access' || location.pathname.startsWith('/exhibit/'))) return true;
    if (path === '/visitor-info' && location.pathname === '/visitor-info') return true;
    return false;
  };
  
  return (
    <footer className="bg-white border-t border-gray-200 py-2 sticky bottom-0 z-30 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.05)]">
      <div className="agam-color-bar"></div>
      <div className="museum-container">
        {/* Navigation */}
        <nav className="flex justify-around items-center">
          <Link 
            to="/" 
            className={`flex flex-col items-center py-3 px-4 min-w-[68px] text-museum-text transition-colors ${isActive('/') ? 'text-museum' : 'hover:text-museum'}`}
          >
            <Home className={`h-6 w-6 ${isActive('/') ? 'text-museum' : ''}`} />
            <span className="text-xs mt-1 font-medium">{getLabel('home')}</span>
          </Link>
          
          <Link 
            to="/tours" 
            className={`flex flex-col items-center py-3 px-4 min-w-[68px] text-museum-text transition-colors ${isActive('/tours') ? 'text-museum' : 'hover:text-museum'}`}
          >
            <Compass className={`h-6 w-6 ${isActive('/tours') ? 'text-museum' : ''}`} />
            <span className="text-xs mt-1 font-medium">{getLabel('tours')}</span>
          </Link>
          
          <Link 
            to="/exhibit-access" 
            className={`flex flex-col items-center py-3 px-4 min-w-[68px] text-museum-text transition-colors ${isActive('/exhibit-access') ? 'text-museum' : 'hover:text-museum'}`}
          >
            <KeypadIcon />
            <span className="text-xs mt-1 font-medium">{getLabel('keypad')}</span>
          </Link>
          
          <Link 
            to="/visitor-info" 
            className={`flex flex-col items-center py-3 px-4 min-w-[68px] text-museum-text transition-colors ${isActive('/visitor-info') ? 'text-museum' : 'hover:text-museum'}`}
          >
            <Info className={`h-6 w-6 ${isActive('/visitor-info') ? 'text-museum' : ''}`} />
            <span className="text-xs mt-1 font-medium">{getLabel('info')}</span>
          </Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
